import React from 'react';
import './People.css';
import { Container, Row, Col, Nav, Badge } from 'react-bootstrap';
import { MyRole } from '../../components';
import { Link, useLocation } from 'react-router-dom';

const Roles = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <Container fluid className="team-page">
            <Row>
                <Col>
                    <h1 className="display-1">Roles</h1>
                    <div className="display-2">Manage Your Team Roles</div>
                </Col>
                <Col>
                    <div className="text-end">
                        <Nav className="c-nav-tabs">
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/people"
                                    active={currentPath === '/people'}
                                >
                                    People
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/people/roles"
                                    active={currentPath === '/people/roles'}
                                >
                                    Roles
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/people/workload"
                                    active={currentPath === '/people/workload'}
                                >
                                    Workload
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/people/skills"
                                    active={currentPath === '/people/skills'}
                                >
                                    Skills <Badge bg="success" pill className="ms-2 new-badge">NEW</Badge>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Col>
            </Row>
            <Row className="mt-0 gy-4">
                <Col lg={12}>                    
                    <MyRole />
                </Col>
            </Row>
        </Container>  
    );
};

export default Roles;
